import Swal from 'sweetalert2';
import styled from 'styled-components';
import withReactContent from 'sweetalert2-react-content';

const DescriptionText = styled.p`
    color: rgba(58, 57, 57, 1);
    text-align: center;
    font-weight: 500;
    font-size: 14px;
    font-family: 'Montserrat';
    margin-top: 10px;
    padding: 0% 8%;
`;

const OptionText = styled.p`
    color: rgba(41, 37, 97, 1);
    text-align: center;
    font-weight: 500;
    font-size: 16px;
    font-family: 'Montserrat';
    margin-top: 20px;
    padding: 2% 10%;
`;

const ButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    padding-bottom: 10px;
`;

const NoButton = styled.button`
    background: rgba(176, 206, 251, 1);
    color: rgba(58, 57, 57, 1);
    font-family: 'Montserrat';
    font-weight: 700;
    border: none;
    border-radius: 20px;
    padding: 10px 70px;
    font-size: 10px;
    cursor: pointer;
    &:hover {
        background: rgba(176, 206, 251, 0.8);
    }
`;

const YesButton = styled.button`
    background: rgba(186, 29, 29, 1);
    color: white;
    font-family: 'Montserrat';
    border: none;
    border-radius: 20px;
    padding: 10px 30px;
    width: 250px;
    font-size: 10px; /* Adjusted font size */
    margin-left: 20px;
    cursor: pointer;

    &:hover {
        background: rgba(186, 29, 29, 0.8);
    }
`;

const StyledModalHeader = styled.h2`
    background: rgb(234, 222, 208, 1);
    color: rgba(41, 37, 97, 1);
    text-align: center;
    font-weight: 700;
    font-size: 24px;
    font-family: 'Montserrat';
    padding-top: 10px;
    margin: 0;
`;

const StyledModalBody = styled.div`
    background: rgb(234, 222, 208, 1);
    color: rgba(41, 37, 97, 1) !important;
    text-align: center;
    font-weight: 700;
    font-size: 24px;
    font-family: 'Montserrat';
    padding-top: 10px;
    margin: 0;
`;

const MySwal = withReactContent(Swal);

export default function modalSuccessClaimsCreate(refNo, navigate, clearClaimsData) {
    const copyRefNo = async (refNo) => {
        navigator.clipboard
            .writeText(refNo)
            .then(() => {
                console.log('copied');
            })
            .catch((error) => {
                console.error('Error copying text: ', error);
            });
    };

    MySwal.fire({
        html: (
            <StyledModalBody>
                <StyledModalHeader>Success</StyledModalHeader>
                <DescriptionText>
                    Thank you for your submission. Please expect a message from our Claims team via email shortly.
                </DescriptionText>
                <OptionText>Your Acknowledgement Reference Number</OptionText>
                <ButtonContainer>
                    <YesButton onClick={() => copyRefNo(refNo)}>
                        <i className="bi bi-copy" style={{ padding: '8px', fontSize: '20px' }}>
                            {' ' + refNo}
                        </i>
                    </YesButton>
                </ButtonContainer>
                <DescriptionText>
                    <br />
                    <b>Important: </b> Please copy and save your Acknowledgement Reference Number above for future
                    reference. You will also find this number in the email we send to acknowledge your claims report.
                    You may need it to track your claim status or for any further inquiries.
                </DescriptionText>
            </StyledModalBody>
        ),
        showConfirmButton: false,
        showCloseButton: true,
        customClass: {
            popup: 'my-popup',
            closeButton: 'my-close-button'
        },
        backdrop: `
            rgba(159, 159, 159, 0.5)
        `,
        allowOutsideClick: false,
        allowEscapeKey: false
    }).then((result) => {
        if (result.isDismissed) {
            navigate('/home');
            clearClaimsData();
        }
    });
}
